// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_0-B","cls2":"DebugPage-cls2_zOa DebugPage-cls1_0-B"};